var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('circle',{class:_vm.circleClass,attrs:{"cx":_vm.point.x,"cy":_vm.point.y,"r":_vm.size}})}
var staticRenderFns = []

export { render, staticRenderFns }